import { FilePath } from 'app/model/dataset/file-path';
import { IModel, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { Location } from 'app/model/dataset/location/location';
import { AmazonS3CompatibleLinkedService } from 'app/model/linkedservice/amazon-s3-compatible.linkedservice';
import { stringIsNullOrEmpty } from 'app/shared/utils/string.util';
import { ILocationPath } from 'shell-models-lib';

@Metamodel.model({
    name: 'AmazonS3CompatibleLocation',
    tags: {
        linkedServiceModel: Metamodel.modelFor(AmazonS3CompatibleLinkedService)
    }
})
export class AmazonS3CompatibleLocation extends Location {
    public static readonly MODEL: IModel;
    public static readonly CONTAINER: IAttribute;
    public static readonly FOLDER_PATH: IAttribute;
    public static readonly FILE_NAME: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_Container,
        association: 'CONTAINER',
        templatable: true
    })
    public container?: string;

    @Metamodel.attribute({
        display: stringResources.FolderPath_Label,
        association: 'FOLDER_PATH',
        templatable: true
    })
    public folderPath?: string;

    @Metamodel.attribute({
        display: stringResources.FileNameLabel,
        association: 'FILE_NAME',
        templatable: true
    })
    public fileName?: string;

    public setLocation(path: FilePath): void {
        this.folderPath = path.folderPath;
        this.fileName = path.fileName;
        this.container = path.container;
    }

    public setParameterizedLocation(path: ILocationPath): void {
        this.setPathPropertyValue('folderPath', AmazonS3CompatibleLocation.FOLDER_PATH, path);
        this.setPathPropertyValue('fileName', AmazonS3CompatibleLocation.FILE_NAME, path);
        this.setPathPropertyValue('container', AmazonS3CompatibleLocation.CONTAINER, path);
    }

    public getLocation(): FilePath {
        const path = new FilePath();
        path.folderPath = this.folderPath;
        path.fileName = this.fileName;
        path.container = this.container;
        return path;
    }

    public getParameterizedLocation(): ILocationPath {
        return {
            folderPath: AmazonS3CompatibleLocation.FOLDER_PATH.templateValue(this) || this.folderPath,
            fileName: AmazonS3CompatibleLocation.FILE_NAME.templateValue(this) || this.fileName,
            container: AmazonS3CompatibleLocation.CONTAINER.templateValue(this) || this.container
        };
    }

    public getFolderPath(): string {
        return this.folderPath;
    }

    public isFolder(fileNameParameterAsFile: boolean = true): boolean {
        return fileNameParameterAsFile && AmazonS3CompatibleLocation.FILE_NAME.templateValue(this)
            ? false
            : !this.fileName;
    }

    public isLocationParameterized(): boolean {
        return !stringIsNullOrEmpty(AmazonS3CompatibleLocation.CONTAINER.templateValue(this)) ||
            !stringIsNullOrEmpty(AmazonS3CompatibleLocation.FOLDER_PATH.templateValue(this)) ||
            !stringIsNullOrEmpty(AmazonS3CompatibleLocation.FILE_NAME.templateValue(this));
    }
}
